<template>
    <section class="dp-layout">

        <section class="dp-left">
            <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>

        <section class="dp-right">
            <div class="toolbar-filter-bar">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters" class="toolbar-filter-form">
                    <div class="toolbar-filter-fields">
                    <el-form-item>
                        <el-input v-model="filters.createBy" placeholder="检查人" clearable
                            class="toolbar-field-w-sm"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="filters.studentName" placeholder="学生姓名" clearable
                            class="toolbar-field-w-sm"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filters.sourceType" placeholder="来源" clearable class="toolbar-field-w-sm"
                            @change="handleQuery">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="值周录入" value="DutyInspect"></el-option>
                            <el-option label="黑板报" value="Blackboard"></el-option>
                            <el-option label="班务" value="ClassAffair"></el-option>
                            <el-option label="宿舍检查" value="DormInspect"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filters.changeType" placeholder="类型" clearable class="toolbar-field-w-sm"
                            @change="handleQuery">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="加分" value="Addition"></el-option>
                            <el-option label="扣分" value="Deduction"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-cascader v-model="filters.categoryId" :options="categoryOptions"
                            :props="{ checkStrictly: true }" placeholder="检查项目" clearable
                            class="toolbar-field-w-md"></el-cascader>
                    </el-form-item>

                    <!-- 学期选择 -->
                    <el-form-item>
                        <el-select v-model="selectedSemesterId" placeholder="学期" @change="handleSemesterChange"
                            class="toolbar-field-w-lg">
                            <el-option v-for="sem in semesterList" :key="sem.Id" :label="sem.SemesterName"
                                :value="sem.Id"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 快捷时间筛选 -->
                    <el-form-item style="margin-left: 10px;">
                        <el-link :type="timeRange === 'today' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('today')" style="margin-right: 15px;"
                            :underline="false">今日</el-link>
                        <el-link :type="timeRange === 'week' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('week')" style="margin-right: 15px;"
                            :underline="false">本周</el-link>
                        <el-link :type="timeRange === 'month' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('month')" style="margin-right: 15px;"
                            :underline="false">本月</el-link>
                        <el-link :type="timeRange === 'semester' ? 'primary' : 'default'"
                            @click="handleTimeRangeChange('semester')" style="margin-right: 15px;"
                            :underline="false">全学期</el-link>

                        <el-dropdown trigger="click" @command="handleCustomTimeCommand" style="margin-right: 10px;"
                            placement="bottom">
                            <span class="el-dropdown-link"
                                :style="{ color: timeRange === 'custom' ? 'var(--btn-primary, #2563eb)' : '#606266', cursor: 'pointer', fontSize: '14px' }">
                                自定义时间<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown" style="padding: 10px;">
                                <div @click.stop>
                                    <el-date-picker v-model="filters.dateRange" type="daterange" format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"
                                        :clearable="false" size="small" @change="onCustomDateChange"
                                        class="toolbar-field-w-daterange">
                                    </el-date-picker>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
                    </el-form-item>
                    </div>
                    <div class="toolbar-filter-actions">
                        <el-button type="danger" size="small" icon="el-icon-delete" :disabled="selectedRows.length === 0"
                            @click="handleBatchDelete">批量删除</el-button>
                        <el-button type="warning" size="small" icon="el-icon-download" @click="exportExcel">导 出</el-button>
                    </div>
                </el-form>
            </el-col>
            </div>

            <!-- 检查记录表（从后端按部门+时间获取） -->
                        <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
                        <div class="tbl-scroll-host">
                        <el-table height="100%" :data="recordsList" v-loading="recordsLoading" class="duty-record-table" size="small"
                style="width: 100%;" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="DepartmentName" label="班级" width="108" show-overflow-tooltip></el-table-column>
                <el-table-column label="来源" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="isDormSource(scope.row)" type="warning" size="mini" effect="plain">
                            {{ scope.row.SourceLabel || '宿舍检查' }}
                        </el-tag>
                        <el-tag v-else-if="isBlackboardSource(scope.row)" type="success" size="mini" effect="plain">
                            {{ scope.row.SourceLabel || '黑板报' }}
                        </el-tag>
                        <el-tag v-else-if="isClassAffairSource(scope.row)" size="mini" effect="plain">
                            {{ scope.row.SourceLabel || '班务' }}
                        </el-tag>
                        <el-tag v-else type="info" size="mini" effect="plain">
                            {{ scope.row.SourceLabel || '值周录入' }}
                        </el-tag>
                        <el-tooltip v-if="scope.row.SourceRemark" effect="dark" placement="top"
                            :content="scope.row.SourceRemark">
                            <div class="source-remark">{{ scope.row.SourceRemark }}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="学生" min-width="88" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" placement="top" :content="formatStudents(scope.row) || '—'">
                            <span class="cell-nowrap">{{ formatStudents(scope.row) || '' }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="检查项目" min-width="140" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" placement="top" :content="formatCategory(scope.row) || '—'">
                            <span class="cell-nowrap">{{ formatCategory(scope.row) }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="摘要" min-width="220" class-name="col-summary">
                    <template slot-scope="scope">
                        <div class="summary-cell">
                            <el-tooltip effect="dark" placement="top"
                                :content="getRecordSummary(scope.row) || '—'">
                                <div class="summary-clamp">{{ getRecordSummary(scope.row) || '—' }}</div>
                            </el-tooltip>
                            <el-link v-if="isSummaryLong(scope.row)" type="primary" :underline="false"
                                class="summary-more-link"
                                @click.native.stop="openRecordFromList(scope.row)">查看全文</el-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="类型" width="88" align="center">
                    <template slot-scope="scope">
                        <div v-if="recordChangeTypes(scope.row).length" class="type-tags">
                            <el-tag v-for="t in recordChangeTypes(scope.row)" :key="t"
                                :type="t === 'Addition' ? 'success' : 'danger'" size="mini" effect="plain">
                                {{ t === 'Addition' ? '加分' : '扣分' }}
                            </el-tag>
                        </div>
                        <span v-else>—</span>
                    </template>
                </el-table-column>

                <el-table-column prop="TotalScore" label="总分" width="72" align="center">
                    <template slot-scope="scope">
                        <span :class="scoreClass(scope.row.TotalScore)">{{ formatDecimal(scope.row.TotalScore) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="TeacherName" label="检查人" width="88" show-overflow-tooltip></el-table-column>
                <el-table-column label="检查时间" width="158" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="cell-nowrap">{{ scope.row.CreateTime }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="110" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="openRecordFromList(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
                        </div>

            <div style="text-align: right; margin-top: 12px;">
                <el-pagination layout="total, prev, pager, next, jumper" :current-page="recordsPage"
                    :page-size="recordsPageSize" :total="recordsTotal" @current-change="loadRecords"></el-pagination>
            </div>

            <!--工具条-->
            <!-- 记录列表已移至页面主体，相关对话框已移除 -->

            <!-- 记录详情对话框 -->
            <el-dialog title="检查记录详情" :visible.sync="detailDialogVisible"
                :close-on-click-modal="false" width="66%" class="duty-record-detail-dialog">
                <div v-if="detailLoading" style="text-align:center; padding:20px">加载中...</div>
                <div v-else-if="recordDetail">
                    <div class="record-info">
                        <p class="muted">检查教师：<strong>{{ recordDetail.TeacherName }}</strong>&nbsp;&nbsp; 班级：<strong>{{
                            recordDetail.DepartmentName }}</strong>&nbsp;&nbsp; 检查时间：<strong>{{
                                    recordDetail.CreateTime
                                }}</strong>&nbsp;&nbsp; 总分： <span :class="scoreClass(recordDetail.TotalScore)">{{
                                    formatDecimal(recordDetail.TotalScore)
                                }}</span></p>
                        <p v-if="isDormSource(recordDetail)" class="muted" style="margin:6px 0 0 0">
                            来源：
                            <el-tag type="warning" size="mini" effect="plain">{{ recordDetail.SourceLabel || '宿舍检查' }}</el-tag>
                            <span v-if="recordDetail.SourceRemark" style="margin-left:8px;">{{ recordDetail.SourceRemark }}</span>
                            <span style="margin-left:8px;color:#E6A23C;">（宿舍来源不可在本页编辑/删除，请到宿舍检查记录处理）</span>
                        </p>
                        <p v-else-if="isBlackboardSource(recordDetail)" class="muted" style="margin:6px 0 0 0">
                            来源：
                            <el-tag type="success" size="mini" effect="plain">{{ recordDetail.SourceLabel || '黑板报' }}</el-tag>
                            <span v-if="recordDetail.SourceRemark" style="margin-left:8px;">{{ recordDetail.SourceRemark }}</span>
                            <span style="margin-left:8px;color:#67C23A;">（黑板报来源不可改分，删除将同步撤销计分）</span>
                        </p>
                        <p v-else-if="isClassAffairSource(recordDetail)" class="muted" style="margin:6px 0 0 0">
                            来源：
                            <el-tag size="mini" effect="plain">{{ recordDetail.SourceLabel || '班务' }}</el-tag>
                            <span v-if="recordDetail.SourceRemark" style="margin-left:8px;">{{ recordDetail.SourceRemark }}</span>
                            <span style="margin-left:8px;">（班务来源不可改分、不可删除）</span>
                        </p>
                        <p class="summary">摘要：<span class="record-summary">{{
                            recordDetail.SelectedItemsSummary }}</span>
                        </p>
                        <p v-if="recordDetail.StudentsJson || recordDetail.Students || recordDetail.StudentList"
                            class="muted" style="margin:6px 0 0 0">学生：<strong>{{ formatStudents(recordDetail)
                                }}</strong></p>
                        <p v-if="recordDetail.Remark" class="muted" style="margin:6px 0 0 0">备注：<span>{{
                            recordDetail.Remark
                                }}</span></p>
                        <div v-if="recordDetail.MediaFiles && showImage(recordDetail.MediaFiles).length > 0"
                            style="margin-top:8px">
                            <oss-media-thumbs :media="recordDetail.MediaFiles" thumb-width="80px" />
                        </div>
                    </div>
                    <el-table :data="recordDetail.Items || []" style="width: 100%; margin-top:10px" border
                        class="duty-record-detail-table">
                        <el-table-column :resizable="false" prop="ItemName" label="检查项" width="260"
                            class-name="detail-item-column">
                        </el-table-column>

                        <el-table-column :resizable="false" prop="ChangeType" label="类型" width="76" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.ChangeType === 'Addition' ? 'success' : 'danger'" size="small">
                                    {{ scope.row.ChangeType === 'Addition' ? '加分' : '扣分' }}
                                </el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column :resizable="false" prop="Score" label="分值" width="76">
                            <template slot-scope="scope">
                                <span :class="scoreClass(scope.row.Score)">{{ formatDecimal(scope.row.Score)
                                }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column :resizable="false" prop="UnitScore" label="单项分" width="84">
                            <template slot-scope="scope">
                                <span :class="scoreClass(scope.row.UnitScore)">{{ formatDecimal(scope.row.UnitScore)
                                }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column :resizable="false" prop="Quantity" label="数量" width="76"></el-table-column>
                        <el-table-column :resizable="false" label="学生" width="140">
                            <template slot-scope="scope">{{ formatStudents(scope.row) }}</template>
                        </el-table-column>
                        <el-table-column :resizable="false" label="媒体文件" width="160">
                            <template slot-scope="scope">
                                <oss-media-thumbs v-if="showImage(scope.row.MediaFiles).length > 0"
                                    :media="scope.row.MediaFiles" :max="3" />
                                <div v-else-if="scope.row.MediaFiles" style="word-break:break-all">{{
                                    showImage(scope.row.MediaFiles).join(';') }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column :resizable="false" prop="Remark" label="备注" min-width="180"
                            show-overflow-tooltip></el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="detailDialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>

            <!-- 主统计分页已移除 -->

        </section>

    </section>
</template>

<script>
import util from "../../../util/date";
import { getSecondLevel, getRecordDetail, batchDeleteDutyRecord, exportRecordDetail } from '../../api/modules/moral-education';
import { getSemesterList } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
    components: { Toolbar, DepartmentPane },
    data() {
        return {
            filters: {
                createBy: '',
                studentName: '',
                categoryId: null,
                sourceType: '',
                changeType: '',
                dateRange: []
            },
            semesterList: [],
            selectedSemesterId: null,
            currentSemesterObj: null,
            timeRange: 'semester',
            categoryOptions: [],
            buttonList: [],
            // records shown in page
            defaultProps: {
                children: "children",
                label: "label",
            },
            statusList: [
                { name: "激活", value: true },
                { name: "禁用", value: false },
            ],
            recordsLoading: false,
            DepartmentId: "",
            dialogVisible: false,
            currentDate: "",

            deptId: "",
            // 详情弹窗
            detailDialogVisible: false,
            recordDetail: null,
            detailLoading: false,
            /** 超过该字数显示「查看全文」（约两行） */
            summaryMaxLen: 36,
            recordsList: [],
            // recordsLoading 已在上方合并
            recordsPage: 1,
            recordsPageSize: 10,
            recordsTotal: 0,
            BaseApiUrl: BaseApiUrl,
            selectedRows: [],
        };
    },
    computed: {
    },
    methods: {
        scoreClass(val) {
            if (val === null || val === undefined || val === '') return '';
            const n = Number(val);
            if (isNaN(n)) return '';
            if (n > 0) return 'add-value';
            if (n < 0) return 'deduct-value';
            return '';
        },
        /** 是否宿舍检查同步来源。创建于 2026-09-14 */
        isDormSource(row) {
            if (!row) return false;
            return row.SourceType === 'DormInspect' || row.SourceLabel === '宿舍检查';
        },
        /** 是否黑板报来源。创建于 2026-09-24 */
        isBlackboardSource(row) {
            if (!row) return false;
            return row.SourceType === 'Blackboard' || row.SourceLabel === '黑板报';
        },
        /** 是否班务来源。创建于 2026-09-25 */
        isClassAffairSource(row) {
            if (!row) return false;
            return row.SourceType === 'ClassAffair' || row.SourceLabel === '班务';
        },
        /** 是否允许编辑。宿舍/黑板报不可改分。创建于 2026-09-24 */
        canEditDutyRecord(row) {
            if (!row) return false;
            if (this.isDormSource(row) || this.isBlackboardSource(row) || this.isClassAffairSource(row)) return false;
            if (row.CanEdit === false) return false;
            return true;
        },
        /** 是否允许删除。宿舍不可删；黑板报可删（回写撤销）。创建于 2026-09-24 */
        canDeleteDutyRecord(row) {
            if (!row) return false;
            if (this.isDormSource(row) || this.isClassAffairSource(row)) return false;
            return true;
        },
        getStatusColor(status) {
            if (status != "normal") {
                return 'red';
            }
            return '';
        },
        formatDecimal(val) {
            if (val === null || val === undefined || val === '') return '';
            const n = Number(val);
            if (isNaN(n)) return val;
            return n.toFixed(2);
        },
        treeNodeClick(data, node, component) {
            if (!data) this.DepartmentId = null;
            else this.DepartmentId = data.value;

            // 同步加载二级分类用于搜索下拉
            this.loadSecondLevel(this.DepartmentId);
            // 加载学期
            this.loadSemesters();
        },

        // 加载学期列表
        loadSemesters() {
            if (!this.DepartmentId) return;
            getSemesterList({ departmentId: this.DepartmentId }).then(res => {
                if (res.success && res.response && res.response.length > 0) {
                    this.semesterList = res.response;
                    let current = res.response.find(s => s.IsCurrent === 1) || res.response[0];
                    this.selectedSemesterId = current.Id;
                    this.currentSemesterObj = current;
                    // 默认选择“全学期”
                    this.handleTimeRangeChange('semester');
                } else {
                    this.semesterList = [];
                    this.selectedSemesterId = null;
                    this.currentSemesterObj = null;
                    this.handleQuery();
                }
            });
        },

        handleSemesterChange(val) {
            let s = this.semesterList.find(x => x.Id === val);
            if (s) {
                this.currentSemesterObj = s;
                if (this.timeRange === 'semester') {
                    this.handleTimeRangeChange('semester');
                } else {
                    this.handleQuery();
                }
            }
        },

        handleCustomTimeCommand() {
            this.timeRange = 'custom';
        },

        onCustomDateChange(val) {
            if (val && val.length === 2) {
                this.timeRange = 'custom';
                this.handleQuery();
            }
        },

        // 时间范围快捷切换
        handleTimeRangeChange(val) {
            this.timeRange = val;
            const todayDate = new Date();
            const todayStr = util.formatDate.format(todayDate, 'yyyy-MM-dd');
            let start = '';
            let end = '';

            if (val === 'today') {
                start = todayStr;
                end = todayStr;
            } else if (val === 'week') {
                start = util.formatDate.format(util.getStartOfWeek(todayDate), 'yyyy-MM-dd');
                end = util.formatDate.format(util.getEndOfWeek(todayDate), 'yyyy-MM-dd');
            } else if (val === 'month') {
                start = util.formatDate.format(util.getStartOfMonth(todayDate), 'yyyy-MM-dd');
                end = util.formatDate.format(util.getEndOfMonth(todayDate), 'yyyy-MM-dd');
            } else if (val === 'semester') {
                if (this.currentSemesterObj && this.currentSemesterObj.StartDate && this.currentSemesterObj.EndDate) {
                    start = this.currentSemesterObj.StartDate.substring(0, 10);
                    end = this.currentSemesterObj.EndDate.substring(0, 10);
                } else {
                    // 默认半年前到今天
                    const d = new Date();
                    d.setMonth(d.getMonth() - 6);
                    start = util.formatDate.format(d, 'yyyy-MM-dd');
                    end = todayStr;
                }
            } else {
                return;
            }

            this.$set(this.filters, 'dateRange', [start, end]);
            this.handleQuery();
        },

        // 加载二级分类并填充 searchList 中的 categoryId 下拉选项
        loadSecondLevel(departmentId) {
            if (!departmentId) return;
            getSecondLevel({ departmentId: departmentId }).then(res => {
                if (res && res.data && res.data.success) {
                    const list = res.data.response || [];
                    // 构建父-子树形 options，供 el-cascader 使用（显示一级并联动二级）
                    const opts = (list || []).map(parent => ({
                        label: parent.Name || '',
                        value: parent.Id || parent.Id,
                        children: (parent.Children || []).map(child => ({
                            label: child.Name || '',
                            value: child.Id || child.Id
                        }))
                    }));
                    // 将 options 写入本地变量或父组件属性中，但在这里我们使用的是 el-form 原生组件
                    this.categoryOptions = opts;
                } else {
                    // 无数据时清空 options
                    this.categoryOptions = [];
                }
            }).catch(() => {
                this.categoryOptions = [];
            });
        },

        // 查询记录：按部门+时间请求记录明细并填充页面表格
        handleQuery() {
            const deptId = this.DepartmentId;
            let startDate = '';
            let endDate = '';
            if (this.filters.dateRange && this.filters.dateRange.length === 2) {
                startDate = this.filters.dateRange[0];
                endDate = this.filters.dateRange[1];
            }
            this.loadRecords(1, deptId, startDate, endDate);
        },

        // removed categoryColumns helpers

        // 格式化带符号的分值（用于总加分/总扣分列）
        formatSigned(val, type) {
            if (val === null || val === undefined || val === '') return '';
            const n = Number(val);
            if (isNaN(n)) return val;
            if (n === 0) return n.toFixed(2);
            const abs = Math.abs(n).toFixed(2);
            return (type === 'add' ? '+' : '-') + abs;
        },

        formatStudents(row) {
            if (!row) return '';
            const collectFromJson = src => {
                if (!src) return [];
                try {
                    if (typeof src === 'string') return JSON.parse(src);
                    if (Array.isArray(src)) return src;
                } catch (e) {
                    return [];
                }
                return [];
            };

            const names = new Set();

            // 支持顶层的 StudentsJson / Students / StudentList
            const topSrc = row.StudentsJson || row.Students || row.StudentList;
            if (topSrc) {
                const arr = collectFromJson(topSrc);
                arr.forEach(x => {
                    const n = x && (x.name || x.Name || x.studentName || '');
                    if (n) names.add(n);
                });
            }

            // 支持从 Items 中聚合学生
            if (Array.isArray(row.Items)) {
                row.Items.forEach(item => {
                    const s = item.StudentsJson || item.Students || item.StudentList;
                    const arr = collectFromJson(s);
                    arr.forEach(x => {
                        const n = x && (x.name || x.Name || x.studentName || '');
                        if (n) names.add(n);
                    });
                });
            }

            return Array.from(names).join(', ');
        },

        formatCategory(row) {
            if (!row) return '';
            const makeDisplay = (p, c) => {
                const parent = p ? String(p).trim() : '';
                const child = c ? String(c).trim() : '';
                return parent ? (child ? `${parent}/${child}` : parent) : child;
            };

            // 优先使用直接字段
            if (row.ParentCategoryName || row.CategoryName) {
                return makeDisplay(row.ParentCategoryName, row.CategoryName) || '';
            }
        },

        /** 取记录摘要原文 */
        getRecordSummary(row) {
            if (!row) return '';
            const text = row.SelectedItemsSummary;
            return text == null ? '' : String(text).trim();
        },

        /** 摘要是否超出列表展示长度 */
        isSummaryLong(row) {
            return this.getRecordSummary(row).length > this.summaryMaxLen;
        },

        /**
         * 汇总一条检查记录的加分/扣分类型（按明细去重）。最后更新：2026-10-13
         * 同一条记录既有加分又有扣分时，两个标签都显示。
         */
        recordChangeTypes(row) {
            const items = row && Array.isArray(row.Items) ? row.Items : [];
            if (!items.length) return [];
            const hasAddition = items.some(it => it && it.ChangeType === 'Addition');
            const hasDeduction = items.some(it => it && it.ChangeType !== 'Addition');
            const types = [];
            if (hasAddition) types.push('Addition');
            if (hasDeduction) types.push('Deduction');
            return types;
        },

        // 点击查看详情（按部门 + 开始/结束时间 分页查询）
        viewRecordDetail(row) {
            const deptId = row.DeptId || row.DepartmentId || this.DepartmentId || row.DeptId;
            const startDate = this.filters && (this.filters.date || this.filters.startDate);
            const endDate = this.filters && (this.filters.endDate || this.filters.end);

            if (!deptId) {
                this.$message.warning('请先选择开始和结束日期以查看该部门的检查明细');
                return;
            }

            // 默认从第一页加载
            this.loadRecords(1, deptId, startDate, endDate);
        },

        // 加载部门在时间范围内的记录列表（分页）
        loadRecords(page = 1, deptId, startDate, endDate) {
            const departmentId = deptId || this.DepartmentId;
            const start = startDate || (this.filters.dateRange && this.filters.dateRange[0]);
            const end = endDate || (this.filters.dateRange && this.filters.dateRange[1]);
            const createBy = this.filters.createBy;
            const studentName = this.filters.studentName;
            if (!departmentId) {
                // 如果未选部门，不强制报错，可能列表为空
                return;
            }
            this.recordsLoading = true;
            const params = {
                departmentId: departmentId,
                startDate: start,
                endDate: end,
                page: page,
                intPageSize: this.recordsPageSize || 10,
            };
            if (createBy) {
                params.createBy = createBy;
            }
            if (studentName) {
                params.studentName = studentName;
            }
            if (this.filters.sourceType) {
                params.sourceType = this.filters.sourceType;
            }
            if (this.filters.changeType) {
                params.changeType = this.filters.changeType;
            }
            // include categoryId if present (cascader returns array [parentId, childId])
            const cat = this.filters.categoryId;
            if (cat !== undefined && cat !== null) {
                const cid = Array.isArray(cat) ? (cat.length ? cat[cat.length - 1] : null) : cat;
                if (cid) params.categoryId = cid;
            }
            getRecordDetail(params).then(async (res) => {
                if (res.data && res.data.success) {
                    const resp = res.data.response || {};
                    // 支持后端返回分页结构 resp.data
                    if (Array.isArray(resp.data)) {
                        const rows = resp.data;
                        await this.prefetchListOssMedia(rows, 'MediaFiles');
                        this.recordsList = rows;
                        this.recordsTotal = resp.dataCount || resp.dataCount || 0;
                        this.recordsPage = resp.page || page;
                        this.recordsPageSize = resp.PageSize || this.recordsPageSize;
                    } else if (Array.isArray(res.data.response)) {
                        this.recordsList = res.data.response;
                        this.recordsTotal = res.data.response.length;
                        this.recordsPage = page;
                    } else {
                        // 如果直接返回单条详情对象，则打开详情对话框
                        this.recordDetail = resp;
                        this.detailDialogVisible = true;
                    }
                } else {
                    this.$message.error(res.data ? res.data.msg : '获取记录列表失败');
                }
            }).catch(() => {
                this.$message.error('获取记录列表出错');
            }).finally(() => {
                this.recordsLoading = false;
            });
        },

        // 从记录列表中查看某条记录详情（按 RecordId 再次调用）
        openRecordFromList(item) {
            // 直接使用 recordsList 中已经包含的项（包含 Items 明细），无需再次请求接口
            if (!item) {
                this.$message.warning('选中记录无效');
                return;
            }
            this.recordDetail = item;
            this.detailDialogVisible = true;
        },

        async exportExcel() {
            try {
                const deptId = this.DepartmentId;
                const startDate = this.filters.dateRange && this.filters.dateRange[0];
                const endDate = this.filters.dateRange && this.filters.dateRange[1];
                const createBy = this.filters.createBy;
                const studentName = this.filters.studentName;

                const params = {
                    departmentId: deptId,
                    startDate: startDate,
                    endDate: endDate,
                    createBy: createBy,
                    studentName: studentName
                };
                if (this.filters.sourceType) {
                    params.sourceType = this.filters.sourceType;
                }
                if (this.filters.changeType) {
                    params.changeType = this.filters.changeType;
                }

                const cat = this.filters.categoryId;
                if (cat !== undefined && cat !== null) {
                    const cid = Array.isArray(cat) ? (cat.length ? cat[cat.length - 1] : null) : cat;
                    if (cid) params.categoryId = cid;
                }

                var fileName = "检查记录明细";
                const response = await exportRecordDetail(params);
                if (!response.data) {
                    this.$message({
                        message: "导出数据为空",
                        type: "error",
                    });
                    return;
                }
                // 处理导出数据        
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const startDateStr = startDate || new Date().toISOString().split('T')[0];
                const endDateStr = endDate || startDateStr;
                link.setAttribute('download', `检查记录明细_${startDateStr}_${endDateStr}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (error) {
                this.$message.error('导出出错');
                console.error('下载失败:', error);
            }
        },

        handleSelectionChange(val) {
            this.selectedRows = val;
        },

        handleBatchDelete() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请选择要删除的记录');
                return;
            }
            const deletable = this.selectedRows.filter(r => this.canDeleteDutyRecord(r));
            const blocked = this.selectedRows.length - deletable.length;
            if (!deletable.length) {
                this.$message.warning('所选记录均来自宿舍检查，请到「宿舍检查 → 检查记录」删除');
                return;
            }
            const tip = blocked > 0
                ? `已排除 ${blocked} 条不可删除记录。确认删除其余 ${deletable.length} 条？`
                : `确认删除选中的 ${deletable.length} 条记录吗？`;

            this.$confirm(tip, '提示', {
                type: 'warning'
            }).then(() => {
                const ids = deletable.map(row => row.RecordId);
                this.recordsLoading = true;
                batchDeleteDutyRecord(ids).then(res => {
                    if (res.success) {
                        this.$message.success('删除成功');
                        this.handleQuery(); // 刷新列表
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                }).catch(() => {
                    this.$message.error('删除请求失败');
                }).finally(() => {
                    this.recordsLoading = false;
                });
            }).catch(() => { });
        },
    },
    mounted() {
        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
    display: none;
}

.add-value {
    color: #67C23A;
}

.deduct-value {
    color: #F56C6C;
}

.source-remark {
    margin-top: 2px;
    font-size: 12px;
    color: #909399;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 记录详情样式优化 */
.record-info {
    margin-bottom: 12px;
}

.record-info .muted {
    color: #606266;
    margin: 0 0 6px 0;
}

.record-info .summary {
    margin: 0;
    color: #606266;
}

.record-score {
    font-weight: 700;
}

.record-summary {
    color: #909399;
}

.el-dialog__body {
    padding: 20px 28px;
}

.duty-record-table ::v-deep th {
    background: #fafafa;
    color: #909399;
    font-weight: 600;
}

.duty-record-table ::v-deep td {
    padding: 8px 6px;
}

.duty-record-table ::v-deep .cell {
    line-height: 20px;
}

.duty-record-table ::v-deep .col-summary .cell {
    white-space: normal;
}

.cell-nowrap {
    white-space: nowrap;
}

.el-dialog__footer {
    padding: 12px 28px;
}

.duty-record-detail-dialog .el-dialog__body {
    overflow-x: auto;
}

.duty-record-detail-table {
    min-width: 980px;
}

.duty-record-detail-table .detail-item-column .cell {
    white-space: normal;
    line-height: 20px;
    word-break: break-all;
}

/* 摘要列：最多两行 + 查看全文 */
.summary-cell {
    line-height: 1.45;
}

.summary-clamp {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    color: #606266;
    font-size: 13px;
    word-break: break-all;
}

.summary-more-link {
    display: inline-block;
    margin-top: 2px;
    font-size: 12px;
    line-height: 1;
}

.type-tags {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

</style>
